import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DanhSachDeTai = _resolveComponent("DanhSachDeTai")!
  const _component_LoginPage = _resolveComponent("LoginPage")!

  return ($setup.isLoggedIn)
    ? (_openBlock(), _createBlock(_component_DanhSachDeTai, { key: 0 }))
    : (_openBlock(), _createBlock(_component_LoginPage, { key: 1 }))
}